import type { FaireProductEntity } from "../../entity_types/product";

export const p_w84yxgx85v: FaireProductEntity = {
  token: "p_w84yxgx85v",
  type: "product",
  name: "Minnesota Loon Whitewash",
  brandName: "Kendrick Home",
  imageUrl:
    "https://cdn.faire.com/fastly/7818031270c46bc0afb58d2571724757991d7b1a17f087c7daad8b53543be1af.jpeg",
  priceDollars: 15.45,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5c8a8c90624a12fa4547bc353b4f8f8b92347732c03d756165aa7e9a840c4848.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
